import React from "react";
import { SiCss3, SiHtml5, SiJavascript, SiStyledComponents, SiTypescript } from "react-icons/si";
import { FaReact, FaNode, FaGit, FaGithub } from "react-icons/fa";
import AboutImg from "../assets/profile.jpg";
import HomeImg from "../assets/profile.jpg";
import SkillsImg from "../assets/work1.webp";

export const routerPath = [
  {
    id: 1,
    link: "home",
    text: "Home",
    active: true,
  },
  {
    id: 2,
    link: "about",
    text: "About",
    active: false,
  },
  {
    id: 3,
    link: "skills",
    text: "Skills",
    active: false,
  },
  {
    id: 4,
    link: "projects",
    text: "Projects",
    active: false,
  },
  {
    id: 5,
    link: "contact",
    text: "Contact",
    active: false,
  },
];

export const webColor = [
  {
    id: 1,
    color: "#00B0FF",
    active: false,
  },
  {
    id: 2,
    color: "#00BFA6",
    active: false,
  },
  {
    id: 3,
    color: "#F50057",
    active: false,
  },
  {
    id: 4,
    color: "#536DFE",
    active: false,
  },
  {
    id: 5,
    color: "#F9A826",
    active: false,
  },
  {
    id: 6,
    color: "#6C63FF",
    active: false,
  },
  {
    id: 7,
    color: "#4070F4",
    active: true,
  },
  {
    id: 8,
    color: "#fa8072",
    active: false,
  },
];

export const skills = [
  {
    id: 1,
    Icon: ({ activeColor }) => (
      <SiHtml5 style={{  fontSize: 30 }} />
    ),
    lang: "html5",
    percentage: "90%",
    BarWidth: "90%",
  },
  {
    id: 1,
    Icon: ({ activeColor }) => (
      <SiCss3 style={{  fontSize: 30 }} />
    ),
    lang: "css3",
    percentage: "85%",
    BarWidth: "85%",
  },
  {
    id: 1,
    Icon: ({ activeColor }) => (
      <SiStyledComponents style={{  fontSize: 30 }} />
    ),
    lang: "styled components",
    percentage: "80%",
    BarWidth: "80%",
  },
  {
    id: 1,
    Icon: ({ activeColor }) => (
      <SiJavascript style={{  fontSize: 30 }} />
    ),
    lang: "javascript",
    percentage: "85%",
    BarWidth: "85%",
  },
  {
    id: 2,
    Icon: ({ activeColor }) => (
      <SiTypescript style={{  fontSize: 30 }} />
    ),
    lang: "typescript",
    percentage: "75%",
    BarWidth: "75%",
  },
  {
    id: 3,
    Icon: ({ activeColor }) => (
      <FaReact style={{  fontSize: 30 }} />
    ),
    lang: "react js",
    percentage: "90%",
    BarWidth: "90%",
  },
  {
    id: 4,
    Icon: ({ activeColor }) => (
      <FaNode style={{  fontSize: 30 }} />
    ),
    lang: "node js",
    percentage: "65%",
    BarWidth: "65%",
  },
  {
    id: 4,
    Icon: ({ activeColor }) => (
      <FaGit style={{  fontSize: 30 }} />
    ),
    lang: "git",
    percentage: "80%",
    BarWidth: "80%",
  },
  {
    id: 4,
    Icon: ({ activeColor }) => (
      <FaGithub style={{  fontSize: 30 }} />
    ),
    lang: "github",
    percentage: "80%",
    BarWidth: "80%",
  },
];

export const home = {
  tittle: "Sathish K",
  button: "Contact",
  button1: "Projects",
  image: HomeImg,
  text1: "Hi,",
  text2: "I'am",
  text3: "Web App Developer",
};

export const contact = {
  header: "Contact",
  button: "Submit",
  message: "Thanks for contacting me.",
};

export const skillData = {
  header: "Skills",
  tittle: "Professional Skills",
  image: SkillsImg,
  content: `I Strive To Develop An Web Application That Improvise Quality And Hassle Free User Experience With The Cutting Edge Technologies And Frameworks.`,
  content1: `
  Led the successful migration of Verizon Business Portal from Angular to React, aligning all functional and UI elements with story Acceptance Criteria, leveraging cutting-edge technologies:
○ ReactJS, Redux, Redux-saga, AEM, Web Components, VDS Verizon Library, Webpack, i18next-react
`,
};

export const work = {
  header: "Projects",
  PortfolioListContent: [
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iam-sathish.appspot.com/o/wheather_app.png?alt=media&token=92a32301-eece-425f-a087-b8be670db46d",
      category: `React JS, Tailwind css, Next Js`,
      title: "Weather Application",
      link: "https://improved-weather-master.vercel.app/",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iam-sathish.appspot.com/o/wsa_sos.png?alt=media&token=6077d95c-ed51-4c1b-94a8-52f8eda3bda0",
      category: `React Native, Twilio, Redux, React-Navigation`,
      title: "WSA SOS",
      link: "https://drive.google.com/file/d/1cYMtd4VKdyuApsDwU52AWlTJpg3x44gM/view?usp=sharing",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iam-sathish.appspot.com/o/admin_dash.png?alt=media&token=33e3df78-f650-4132-881b-c89905b956bc",
      category: `React JS, Styled-components, Bootstrap, Node Js`,
      title: "Porfolio Admin Page",
      link: "https://iam-sathish-2.web.app/admin",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iam-sathish.appspot.com/o/chat.png?alt=media&token=154980d3-fe1e-4765-a073-061672d4f398",
      category: `React JS, Socket.io, Bootstrap, Node Js`,
      title: "Private Chat Application",
      link: "https://pingmeanytime.herokuapp.com/",
    },
  ],
};

const calculateExp = () => {
  let df = new Date("08/26/2019");
  let dt = new Date();
  const startMonth = df.getFullYear() * 12 + df.getMonth();
  const endMonth = dt.getFullYear() * 12 + dt.getMonth();
  const monthInterval = endMonth - startMonth;
  const yearsOfExperience = Math.floor(monthInterval / 12);
  const monthsOfExperience = monthInterval % 12;
  return `${yearsOfExperience}.${monthsOfExperience}`;
};

export const about = {
  header: "About",
  image: AboutImg,
  tittle: "I'am Sathish K",
  content: `I'm Software Developer With ${calculateExp()} Years Of Experience Specialized In Web & Hybrid Application Development Using Digital Technologies Ie  React JS,React-Native And Electron ,Having Full Scale Project Development Experience Throughout The Development Cycle Of An Application Having Knowledge In Project Management Platforms Like Jira, Gitlab.`,
  downloadResume:
    "https://docs.google.com/document/d/1kgT3AYhZ8R8HYe3QkTGjFXzFtYhGxWEm/edit?usp=share_link&ouid=113442889696270638678&rtpof=true&sd=true",
};
